var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ThemeProvider',{attrs:{"theme":"campsite"}},[_c('div',{attrs:{"id":"outer-container"}},[_c('Svgs'),_vm._v(" "),_c('SimpleHeader'),_vm._v(" "),_c('main',{attrs:{"id":"main"}},[_c('nuxt')],1),_vm._v(" "),_c('SimpleFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }